<template>
  <AppTooltip :disabled="!fileTooLarge">
    <template #activator="{ props }">
      <!-- We use a wrapper div to retain the disable styling _and_ the tooltip hover event -->
      <div v-bind="props">
        <v-list-item :disabled="fileTooLarge"
                     :density="compact ? 'compact' : 'default' "
                     data-locator="poly-export-menu-item"
                     @click="handleClick">
          <v-list-item-title>
            <div v-if="!btnHasIconAndText" class="d-flex align-center">
              {{ $t('common.polyOffice.PolyOfficeListItemExport.exportFiles') }}
              <v-img src="@/assets/img/LexisPoly.svg"
                    max-height="18"
                    max-width="18"
                    class="ml-2"
              />
            </div>
            <div v-else class="d-flex align-center">
              <v-img src="@/assets/img/LexisPoly.svg"
                    max-height="18"
                    max-width="18"
                    min-width="18"
                    class="img-on-left"
              />
              <span class="text-text-secondary">{{ $t('common.polyOffice.PolyOfficeListItemExport.exportFiles') }}</span>
            </div>
          </v-list-item-title>
        </v-list-item>
      </div>
    </template>
    <span>{{ $t('common.polyOfficeErrors.ERR_FILE_TOO_LARGE', 1) }}</span>
  </AppTooltip>
</template>

<script>
import AppTooltip from '@/common/AppTooltip.vue'

import { POLYOFFICE_MAX_EXPORT_SIZE } from './constants'

export default {
  name: 'PolyOfficeListItemExport',
  components: { AppTooltip },
  props: {
    fileSize: {
      type: Number,
      required: true,
    },
    btnHasIconAndText: {
      type: Boolean,
      default: false,
    },
    compact: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    fileTooLarge () {
      return POLYOFFICE_MAX_EXPORT_SIZE <= this.fileSize
    },
  },
  methods: {
    handleClick () {
      this.$emit('polyOfficeOpenDialog')
    },
  },
}
</script>
<style lang="scss" scoped>
.img-on-left {
  margin-right: 10px;
}
</style>
